export const round = (x: number): number => Math.round(x * 100) / 100;
